import { render, staticRenderFns } from "./remindDialog.vue?vue&type=template&id=493d5a7c&scoped=true"
import script from "./remindDialog.vue?vue&type=script&lang=js"
export * from "./remindDialog.vue?vue&type=script&lang=js"
import style0 from "./remindDialog.vue?vue&type=style&index=0&id=493d5a7c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493d5a7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('493d5a7c')) {
      api.createRecord('493d5a7c', component.options)
    } else {
      api.reload('493d5a7c', component.options)
    }
    module.hot.accept("./remindDialog.vue?vue&type=template&id=493d5a7c&scoped=true", function () {
      api.rerender('493d5a7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/list/components/remindDialog.vue"
export default component.exports